export default "__VITE_ASSET__CzuYcT2N__";